
import SlsTracker from '@aliyun-sls/web-track-browser'

// 错误日志
const opts = {
  host: 'cn-hangzhou.log.aliyuncs.com', // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
  project: 'xhmy-error-logs', // Project名称。
  logstore: 'backstage-management', // Logstore名称。
  time: 10, // 发送日志的时间间隔，默认是10秒。
  count: 10, // 发送日志的数量大小，默认是10条。
  topic: 'topic',// 自定义日志主题。
  source: 'source',
  tags: {
    tags: 'tags',
  },
}

// 数据埋点
const opts2 = {
  host: window.web_config.server_url.indexOf('xinhuomy') != -1 ? 'cn-guangzhou.log.aliyuncs.com' : 'cn-hangzhou.log.aliyuncs.com', // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
  project: window.web_config.server_url.indexOf('xinhuomy') != -1 ? 'xhmy-user-data-back-endmanagement-logs' : 'xhmy-user-data-teachingends-logs', // Project名称。
  logstore: 'hone_management_system', // Logstore名称。
  time: 10, // 发送日志的时间间隔，默认是10秒。
  count: 10, // 发送日志的数量大小，默认是10条。
  topic: 'topic',// 自定义日志主题。
  source: 'source',
  tags: {
    tags: 'tags',
  },
}
const tracker = new SlsTracker(opts)
const tracker2 = new SlsTracker(opts2)


function saveLogToLocalStorage(logEntry) {
  const logs = JSON.parse(localStorage.getItem('pendingLogs')) || [];
  logs.push(logEntry);
  localStorage.setItem('pendingLogs', JSON.stringify(logs));
}
function retryUploadLogs() {
  const pendingLogs = JSON.parse(localStorage.getItem('pendingLogs')) || [];
  if (pendingLogs.length === 0) return;
  pendingLogs.forEach(async (log, index) => {
    try {
      tracker.send(log);
      pendingLogs.splice(index, 1);
      localStorage.setItem('pendingLogs', JSON.stringify(pendingLogs));
    } catch (error) {
      console.error("重试上传失败:", error);
    }
  });
}

export async function logOperation(errorData) {
  const logEntry = {
    user_id: JSON.parse(localStorage.getItem('accountInfo'))?.id || "", // 用户id
    ...errorData,
  }
  tracker2.send(logEntry)
}

export async function logError(errorData) {
  const logEntry = {
    ...errorData,
    name: JSON.parse(localStorage.getItem('accountInfo'))?.realname || "", // 用户名
    user_id: JSON.parse(localStorage.getItem('accountInfo'))?.id || "", // 用户id
    url: window.location.href,
    userAgent: navigator.userAgent,
    resolution: `${window.screen.width}x${window.screen.height}`,
    windowView: `${window.innerWidth}x${window.innerHeight}`,
  };
  try {
    tracker.send(logEntry)
  } catch(err) {
    saveLogToLocalStorage(logEntry)
  }
}
setInterval(retryUploadLogs, 120 * 1000)

window.addEventListener('error', (event) => {
  const errorMsg = event.message || 'Unknown error';
  const stack = event.error?.stack || 'No stack trace';
  logError({
    type: 'UNCAUGHT_ERROR',
    message: `${errorMsg} (${event.filename}:${event.lineno}:${event.colno})`,
    stack,
    timestamp: new Date().toISOString()
  });
});
window.addEventListener('unhandledrejection', (event) => {
  logError({
    type: 'UNCAUGHT_PROMISE',
    message: event.reason.message || String(event.reason),
    stack: event.reason.stack || 'No stack trace',
    timestamp: new Date().toISOString()
  });
});
// function getXPath(element) {
//   if (!element) return '';
//   if (element.id) return `//*[@id="${element.id}"]`;
//   const paths = [];
//   for (; element && element.nodeType === Node.ELEMENT_NODE; element = element.parentNode) {
//     let index = 0;
//     for (let sibling = element.previousSibling; sibling; sibling = sibling.previousSibling) {
//       if (sibling.nodeType === Node.ELEMENT_NODE && sibling.tagName === element.tagName) {
//         index++;
//       }
//     }
//     const tagName = element.tagName.toLowerCase();
//     const pathIndex = (index ? `[${index + 1}]` : '');
//     paths.unshift(tagName + pathIndex);
//   }
//   return paths?.length ? '/' + paths.join('/') : '';
// }
// function getUserId() {
//   return JSON.parse(localStorage.getItem('accountInfo'))?.realname || '未知';
// }
// document.addEventListener('click', (event) => {
//   const target = event.target;
//   const clickLog = {
//     type: 'click',
//     element: {
//       tag: target.tagName,            // 标签名（如 "BUTTON"）
//       id: target.id || '',          // 元素 ID
//       class: target.className || '', // 类名
//       name: target.name || '',       // name 属性（如表单元素）
//       text: target.textContent?.trim().slice(0, 100) || '', // 文本内容（截断前100字符）
//       xpath: getXPath(target),         // 元素的 XPath（用于唯一标识）
//     },
//     page: {
//       url: window.location.href,       // 当前页面 URL
//       title: document.title,           // 页面标题
//     },
//     timestamp: new Date().toISOString(),
//     user: getUserId(),                 // 当前用户标识（根据业务逻辑实现）
//   };
//   tracker.send(clickLog)
//   // 发送日志
//   // logError(clickLog);
// });
